// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"72890ed15ddde4df","5285":"bb0a2da08f1ef3af"}[chunkId] + ".css";
};